import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function putPermissions(data): Promise<AxiosResponse<any, any>> {
    return axiosInstance.put(`Permission/updatePermissions`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getPermissions(
  page = 1, 
  pageSize = 10, 
  userIds?: number[], 
  permissionIds?: number[],
  searchName?: string
): Promise<AxiosResponse<any, any>> {
  let url = `Permission/ListUserPermissions?page=${page}&pageSize=${pageSize}`;
  
  if (userIds && userIds.length > 0) {
    userIds.forEach(id => {
      url += `&userIds=${id}`;
    });
  }
  
  if (permissionIds && permissionIds.length > 0) {
    permissionIds.forEach(id => {
      url += `&permissionIds=${id}`;
    });
  }

  if (searchName && searchName.trim() !== '') {
    url += `&searchName=${encodeURIComponent(searchName.trim())}`;
  }
  

  
  return axiosInstance.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getPermissionsList(): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Permission/List`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getUserPermissions(userId: number): Promise<AxiosResponse<any, any>> {
  return getPermissions(1, 1, [userId]);
}